//
import Model from '@/models/Model'

//
import DetailPurchaseOrderModel from '@/models/Purchase/PchDetailPurchaseOrder'
import PurchaseOrderInvoiceNumModel from '@/models/Purchase/PchPurchaseOrderInvoiceNum'

/**
 *
 */
export default class PchPurchaseInvoice extends Model {
    //
    static includes = [
        'pch_provider.pch_provider_account',
        'pch_provider_branch_offices.g_commune',
        'pch_provider_account_movement.pch_type_provider_account_movement',
        'pch_provider_account_movement.pch_provider_payment.pch_detail_provider_payment_sheet',
        'pch_provider_account_movement.pch_provider_payment.pch_detail_provider_payment_sheets',
        'pch_provider_debt_to_pay',
        'pch_payment_condition',
        'pch_purchase_order_has_invoice_numbers.pch_purchase_order.pch_detail_purchase_orders.wh_product',
        'pch_purchase_order_has_invoice_numbers.pch_purchase_order.pch_detail_purchase_orders.wh_product_service',
        'pch_provider_debt_to_pay.pch_detail_provider_payment_sheets.pch_provider_payment_sheet',
        'pch_provider_debt_to_pay.pch_detail_provider_payment_sheets.pch_provider_account_bank.g_bank',
        'pch_provider_debt_to_pay.pch_detail_provider_payment_sheets.pch_provider_account_bank.g_type_account_bank',
        // 'pch_provider_account_bank.g_bank'
        'pch_detail_purchase_invoices.wh_product',
        'pch_detail_purchase_invoices.wh_product_service ',
    ]
    // [
    //     'pch_provider.pch_provider_account',
    //     'pch_provider_branch_offices.g_commune',
    //     'pch_provider_account_movement.pch_type_provider_account_movement',
    //     'pch_provider_account_movement.pch_provider_payment.pch_detail_provider_payment_sheets',
    //     'pch_payment_condition',
    //     'pch_provider_debt_to_pay.pch_detail_provider_payment_sheets.pch_provider_payment',
    //     'pch_provider_debt_to_pay.pch_detail_provider_payment_sheets.pch_provider_account_bank',
    //     'pch_provider_debt_to_pay.pch_detail_provider_payment_sheets.pch_provider_payment_sheet',
    //     'pch_provider_debt_to_pay.pch_detail_provider_payment_sheets.pch_provider_account_bank.g_bank',
    //     'pch_provider_debt_to_pay.pch_detail_provider_payment_sheets.pch_provider_account_bank.g_type_account_bank',
    // ]
    // 
    
    // init selected
    selected = []

    /**
     *
     */
    get account_number() {
        return this.account ? this.account.account_number : '-'
    }

    fetchEditedDetailPurchaseOrder() {

        //
        let findsPurchaseInvoiceId = this.id

        //
        const firstPurchaseInvoiceOrderId = this.pch_purchase_order_has_invoice_numbers.slice().pop().id
        const findsPurchaseInvoiceOrder = this.pch_purchase_order_has_invoice_numbers.find(item => {
            return item.pch_purchase_invoice_id === findsPurchaseInvoiceId
        })

        //
        findsPurchaseInvoiceId = findsPurchaseInvoiceOrder ? findsPurchaseInvoiceOrder.id : firstPurchaseInvoiceOrderId

        //
        PurchaseOrderInvoiceNumModel
            .modeler()
            .find(findsPurchaseInvoiceId)
            .then(this.setEditedDetail)
    }

    /**
     *
     */
    get is_late() {
        return (
            new Date(this.pch_provider_debt_to_pay_date_to_pay) <
            new Date(Date.now())
        )
    }

    /**
     *
     */
    get pch_provider_debt_to_pay_date_to_pay() {
        return this.pch_provider_debt_to_pay.date_to_pay
    }

    /**
     * Get the payment condition type
     */
    get pch_payment_condition_type() {
        return this.getProperty('pch_payment_condition.type', '-')
    }

    /**
     * Get the provider business name
     */
    get pch_provider_business_name() {
        return this.getProperty('pch_provider.business_name', '')
    }

    /**
     * Get the provider rut
     */
    get pch_provider_rut() {
        return this.getProperty('pch_provider.rut', '')
    }

    /**
     * Get the provider rut
     */
    get pch_purchase_orders_ids() {
        return this.getProperty('pch_purchase_order_has_invoice_numbers', []).map(this.mapHasInvoiceNumbersToPurchaseOrderId)
    }

    /**
     * Map the detail items to selected items
     * 
     * @param {Object} item
     * @returns {Object} selected item
     */
    mapDetailToSelected = item => {
        return {
            ...item.wh_product,
            ...item,
        }
    }

    /**
     * Map the has invoice number items to purchase order id items
     * 
     * @param {Object} item
     * @returns {Object} selected item
     */
    mapHasInvoiceNumbersToPurchaseOrderId = item => {
        return item.pch_purchase_order_id
    }

    /**
     * Map the selected items to details items
     * 
     * @param {Object} item
     * @returns {Object} detail item
     */
    mapSelectedToDetail = item => {
        return {
            "wh_product_id" : item.wh_product_id,
            "wh_product_service_id" : null,
            "quantity" : item.quantity,
            "net_price" : item.net_price,
            "global_discount_line_amount" : item.global_discount_line_amount,
            "global_discount_line_percentage" : item.global_discount_line_percentage,
        }
    }

    /**
     * Reduce the total net price of selected items
     * 
     * @param {Number} total
     * @param {Object} item
     * @returns {Number} total of net price
     */
    reduceSelectedNetTotal = (total, item) => {
        return total += item.net_total
    }

    get selected_details() {
        return this.getProperty('selected', this.mapSelectedToDetail)
    }

    /**
     * Get the total selected net price
     */
    get selected_net_total() {
        return this.getProperty('selected', []).reduce(this.reduceSelectedNetTotal, 0)
    }

    /**
     * Get the iva
     */
    get selected_iva() {
        return Math.max(Math.round(this.selected_net_total * 0.19), 1)
    }

    /**
     * Get the total
     */
    get selected_total() {
        return Math.round(this.selected_net_total * 1.19) + this.extra_tax
    }

    /**
     * 
     */
    setEditedDetail = res => {
        this.selected = res.selected
        //console.log(this.selected)
    }

    /**
     *
     */
    get state() {
        return this.is_late ? 'Atrasado' : 'Por pagar'
    }

    /**
     *
     */
    mapDetailOrder = item => {
        return new DetailPurchaseOrderModel(item)
    }

    /**
     *
     */
    reduceSelected = (total, item) => {
        return [
            ...total,
            ...item.pch_purchase_order.pch_detail_purchase_orders.map(
                this.mapDetailOrder
            ),
        ]
    }

    /**
     *
     */
    reset() {

        if (this.has_purchase_order) {
            this.fetchEditedDetailPurchaseOrder()
        } else {
            this.selected = this.pch_detail_purchase_invoices.map(this.mapDetailToSelected)
        }       

        //
        /*this.selected = this.pch_details_purchase_invoice.reduce(
            this.reduceSelected,
            []
        )*/

        //
        return this
    }

    /**
     *
     */
    resource() {
        return 'pch_purchase_invoice'
    }

    /**
     *
     */
    toCreate() {
        return this.clean([
            'acc_cost_center_id',
            'emission_date',
            'extra_tax',
            'global_discount', //Add new attribute
            'invoice_number',
            'is_exent',
            'iva',
            'new_subtotal',
            'payable',
            'payment_date',
            'pch_payment_condition_id',
            'pch_provider_id',
            'pch_provider_branch_offices_id',
            'total',
        ])
    }

    /**
     * 
     */
    toCreateUnique() {

        //
        this.new_subtotal = this.selected_net_total
        this.iva = this.selected_iva
        this.total = this.selected_total

        //
        this.details = this.selected_details

        //
        return this.clean([
            'acc_cost_center_id',
            'emission_date',
            'extra_tax',
            'global_discount', //Add new attribute
            'details', //Add new attribute
            'invoice_number',
            'is_exent',
            'iva',
            'new_subtotal',
            'payable',
            'payment_date',
            'pch_payment_condition_id',
            'pch_provider_id',
            'pch_provider_branch_offices_id',
            'total',
        ])
    }
}
